module.exports = __webpack_public_path__ + "img/mLinkedin.8aca340.svg";